// extracted by mini-css-extract-plugin
module.exports = {"progress":"loader-wrapper_progress__2-fo1","__react-svg-spinner_circle":"loader-wrapper___react-svg-spinner_circle__dtj1c"};